import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image,
  Box,
  Text
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import Button from '../../Button';
import UserCard from '../../Profile/user-card';
import InformIcon from '../../../assets/inform-green-icon.svg';
import RenderMedia from '../../MediaContainer/media.component';
import { TooltipComponent } from '../../Tooltip';

const EQUITY_PERCENTAGE_TOOLTIP =
  "The percentage of equity the contributor has proposed. If you approve the response, the contributor will receive this percentage of the article's equity. This means they will be credited as a contributor and share in its success.";

function ViewResponseDetailModal(props) {
  const { isOpen, onAccept, onClose, bgColorOverlay, data, onReject } = props;

  const convertStatus = (row) => {
    let text = '';
    let textColor = '';
    let bgColor = '';
    let fontWeight = 0;
    switch (row.status) {
      case 'rejected': {
        text = 'Rejected';
        textColor = '#FFFFFF';
        bgColor = '#DE1414';
        fontWeight = 800;
        break;
      }
      case 'approved': {
        text = 'Accepted';
        textColor = '#FFFFFF';
        bgColor = '#4CAF50';
        fontWeight = 800;
        break;
      }
      case 'pending': {
        text = 'Pending';
        textColor = '#204A22';
        bgColor = '#EDF7EE';
        fontWeight = 600;
        break;
      }
      default: {
      }
    }
    return (
      <Box px={'12px'} rounded={'80px'} bgColor={bgColor} w={'fit-content'}>
        <Text color={textColor} fontSize={'xs'} fontWeight={fontWeight}>
          {text}
        </Text>
      </Box>
    );
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent
        maxW={'708px'}
        maxH={{ base: '80vh', md: '90vh' }}
        p={'24px'}
        bgColor={'#FAFAFA'}
        rounded={'12px'}
      >
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">Response details</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onClose}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody p={'0px'} overflowY={'scroll'}>
          <div className="mt-[24px]">
            <p className="font-[800]">Contributor:</p>
            <div className="mt-2">
              <UserCard user={data?.user} avatarSize="w-[40px] h-[40px]" />
            </div>
          </div>
          <div className="my-[10px] border-b-[2px] border-solid border-04-anti-flash-white"></div>
          <div className="my-[8px]">
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-[5px]">
                <span className="text-growth-green-500 text-[14px] flex items-center gap-[5px]">
                  Proposed Equity
                  <TooltipComponent description={EQUITY_PERCENTAGE_TOOLTIP} Icon={InformIcon} />
                </span>
                <span className="text-[14px]">{data?.equityPercentage}%</span>
              </div>
              {data?.status !== 'pending' ? (
                <div className="flex items-center gap-[5px]">
                  <span className="text-growth-green-500 text-[14px] flex items-center gap-[5px]">
                    Response Status:
                  </span>
                  {convertStatus(data)}
                </div>
              ) : (
                <></>
              )}
              <div className="text-[14px]">
                <p className="font-[800] inline text-[16px]">Title: </p>
                {data?.title}
              </div>
              <div className="text-[16px] text-justify">
                <p className="font-[800] text-[16px]">Notes: </p>
                <p className="text-[14px]">{data?.note}</p>
              </div>
              <div className="flex items-center gap-[5px]">
                <span className="font-[800] inline text-[16px]">Content:</span>
                <Box py={1} px={2} rounded={'80px'} bgColor={'#F0EDEC'} w={'fit-content'}>
                  <Text color={'#6A4E42'} fontWeight={800} fontSize={'xs'}>
                    {data?.contentTypes[0]?.name}
                  </Text>
                </Box>
              </div>
              <RenderMedia type={data?.contentTypes[0]?.name} url={data?.contentUrl} />
            </div>
          </div>
        </ModalBody>
        <ModalFooter w="100%" p={0}>
          {data?.status !== 'pending' ? (
            <Button onClick={onClose} className="w-full h-[42px] text-[16px]">
              Done
            </Button>
          ) : (
            <div className="w-full flex flex-col md:flex-row gap-2 mt-4">
              <Button
                onClick={onReject}
                variant="red"
                className="w-full text-[16px] h-[42px] whitespace-nowrap"
              >
                Reject
              </Button>
              <Button onClick={onAccept} className="w-full h-[42px] text-[16px]">
                Accept
              </Button>
            </div>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ViewResponseDetailModal;
